module.exports = __webpack_public_path__ + "img/img-dash.42c9bdaf.png";